import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { priceFormAction, selectAction } from "../../redux/rootReducer";
import TextareaAutosize from 'react-textarea-autosize';
import { updatePriceSagaAction } from "../../redux/sagaActions";
import { PRICE_FORM_INITIAL, SELECT_INITIAL } from "../../redux/initialStateConstant";
import Select from "../Select/Select";

const PriceForm = () => {
    const dispatch = useDispatch();
    const establishmentList = useSelector(state => state.establishmentList);
    const price_form = useSelector(state => state.price_form);
    const subscription_coaches = useSelector(state => state.subscription_coaches);
    const subscription_types = useSelector(state => state.subscription_types);
    const subscription_constraints = useSelector(state => state.subscription_constraints);
    const subscription_durations = useSelector(state => state.subscription_durations);
    const subscription_workouts_count = useSelector(state => state.subscription_workouts_count);

    if (!price_form.open) return false;

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close"
                            onClick={ () => dispatch(priceFormAction(PRICE_FORM_INITIAL)) }
                        />
                        <div className="form__title">Стоимость</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Название</div>
                        <input type="text" className="input" value={ price_form.name }
                            onInput={ event => dispatch(priceFormAction({
                                ...price_form,
                                name: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Стоимость</div>
                        <input type="text" className="input" value={ price_form.cost }
                            onInput={ event => dispatch(priceFormAction({
                                ...price_form,
                                cost: event.target.value
                            }))}
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Акционная стоимость</div>
                        <input type="text" className="input" value={ price_form.sale }
                               onInput={ event => dispatch(priceFormAction({
                                   ...price_form,
                                   sale: event.target.value
                               }))}
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Тип занятий</div>
                        <Select
                            current={ price_form.type?.name }
                            type={ 'type' }
                            options={ subscription_types }
                            handler={ elem => {
                                dispatch(priceFormAction({
                                    ...price_form,
                                    type: elem
                                }));
                                dispatch(selectAction(SELECT_INITIAL));
                            } }
                            smart={ false }
                        />
                    </div>
                    <div className="form__field">
                        <div className="form__hint">Для занятий без предварительной записи</div>
                        <div className="checkbox__wrapper"
                             style={{ marginTop: 5, marginBottom: 12 }}
                             onClick={ () => {
                                 dispatch(priceFormAction({
                                     ...price_form,
                                     one_time: price_form.one_time === '0' ? '1' : '0'
                                 }));
                             } }
                        >
                            <div className={ `checkbox ${ price_form.one_time === '1' ? 'checkbox--active' : '' }` }/>
                            <div className="checkbox__caption">Разовое занятие</div>
                        </div>
                    </div>
                    {
                        price_form.one_time === '0'
                        ?
                            <>
                                <div className="form__field">
                                    <div className="input__caption input__caption--required">Количество посещений</div>
                                    <Select
                                        current={ price_form.times?.name }
                                        type={ 'times' }
                                        options={ subscription_workouts_count }
                                        handler={ elem => {
                                            dispatch(priceFormAction({
                                                ...price_form,
                                                times: elem
                                            }));
                                            dispatch(selectAction(SELECT_INITIAL));
                                        } }
                                        smart={ false }
                                    />
                                </div>
                                <div className="form__field">
                                    <div className="input__caption input__caption--required">Срок действия</div>
                                    <Select
                                        current={ price_form.duration?.name }
                                        type={ 'duration' }
                                        options={ subscription_durations }
                                        handler={ elem => {
                                            dispatch(priceFormAction({
                                                ...price_form,
                                                duration: elem
                                            }));
                                            dispatch(selectAction(SELECT_INITIAL));
                                        } }
                                        smart={ false }
                                    />
                                </div>
                                <div className="form__field">
                                    <div className="input__caption">Ограничения</div>
                                    <Select
                                        current={ price_form.time_constraint?.name }
                                        type={ 'time_constraint' }
                                        options={ subscription_constraints }
                                        handler={ elem => {
                                            dispatch(priceFormAction({
                                                ...price_form,
                                                time_constraint: elem
                                            }));
                                            dispatch(selectAction(SELECT_INITIAL));
                                        } }
                                        smart={ false }
                                    />
                                </div>
                            </>
                            : false
                    }
                    {
                        subscription_coaches.length > 1
                            ?
                            <div className="form__field">
                                <div className="checkbox__wrapper"
                                     style={{ marginBottom: 12 }}
                                     onClick={ () => {
                                         dispatch(priceFormAction({
                                             ...price_form,
                                             with_coach: price_form.with_coach === '0' ? '1' : '0'
                                         }));
                                     } }
                                >
                                    <div className={ `checkbox ${ price_form.with_coach === '1' ? 'checkbox--active' : '' }` }/>
                                    <div className="checkbox__caption">С тренером</div>
                                </div>
                                {
                                    price_form.with_coach === '1'
                                        ?
                                        <div>
                                            <div className="input__caption">Тренер</div>
                                            <Select
                                                current={ price_form.coach?.name || 'Укажите тренера' }
                                                type={ 'coaches' }
                                                options={ [{ id: '', name: 'Любой тренер' }, ...subscription_coaches.filter(el => el.id)] }
                                                handler={ elem => {
                                                    dispatch(priceFormAction({
                                                        ...price_form,
                                                        coach: elem
                                                    }));
                                                    dispatch(selectAction(SELECT_INITIAL));
                                                } }
                                                smart={ true }
                                            />
                                        </div>
                                        : false
                                }
                            </div>
                            : false
                    }
                    <div className="form__field">
                        <div className="input__caption">Описание</div>
                        <TextareaAutosize
                            className="input input--textarea"
                            value={ price_form.description }
                            onInput={ event => dispatch(priceFormAction({
                                ...price_form,
                                description: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Процент скидки при продлении</div>
                        <input type="text" className="input" value={ price_form.renewal_discount }
                               onInput={ event => dispatch(priceFormAction({
                                   ...price_form,
                                   renewal_discount: event.target.value
                               }))}
                        />
                    </div>
                    <div className="form__field">
                        <div className="checkbox__wrapper"
                             style={{ marginBottom: 12 }}
                             onClick={ () => {
                                 dispatch(priceFormAction({
                                     ...price_form,
                                     online_payment: price_form.online_payment === '0' ? '1' : '0'
                                 }));
                             } }
                        >
                            <div className={ `checkbox ${ price_form.online_payment === '1' ? 'checkbox--active' : '' }` }/>
                            <div className="checkbox__caption">Онлайн оплата</div>
                        </div>
                    </div>
                    <div className="form__field">
                        <div className="checkbox__wrapper"
                             style={{ marginBottom: 12 }}
                             onClick={ () => {
                                 dispatch(priceFormAction({
                                     ...price_form,
                                     first_time_pay: price_form.first_time_pay === '0' ? '1' : '0'
                                 }));
                             } }
                        >
                            <div className={ `checkbox ${ price_form.first_time_pay === '1' ? 'checkbox--active' : '' }` }/>
                            <div className="checkbox__caption">Пробное занятие</div>
                        </div>
                    </div>
                    <div className="form__field">
                        <div className="checkbox__wrapper"
                             style={{ marginBottom: 12 }}
                             onClick={ () => {
                                 dispatch(priceFormAction({
                                     ...price_form,
                                     hide_in_app: price_form.hide_in_app === '0' ? '1' : '0'
                                 }));
                             } }
                        >
                            <div className={ `checkbox ${ price_form.hide_in_app === '1' ? 'checkbox--active' : '' }` }/>
                            <div className="checkbox__caption">Скрыть в приложении</div>
                        </div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required" style={{ marginBottom: '10px' }}>Для каких заведений</div>
                        {
                            establishmentList.map(elem => {
                                return (
                                    <div style={{ marginBottom: '10px' }} key={ elem.id }>
                                        <div className="checkbox__wrapper" onClick={ () => {
                                            // Старый массив с заведениями
                                            let est = [...price_form.establishments];
                                            // Ищем индекс выбранного элемента
                                            let findIndex = est.findIndex(el => el === elem.id);
                                            // Если в массиве есть выбранный элемент, удаляем его
                                            if (findIndex + 1) {
                                                est.splice(findIndex, 1);
                                            }
                                            else {
                                                est.push(elem.id);
                                            }

                                            dispatch(priceFormAction({
                                                ...price_form,
                                                establishments: est
                                            }));

                                        } }>
                                            <div className={ `checkbox ${ price_form.establishments.includes(elem.id) ? 'checkbox--active' : '' }` }/>
                                            <div className="checkbox__caption">{ elem.name }</div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => dispatch(updatePriceSagaAction({
                                id: price_form.id,
                                name: price_form.name,
                                cost: price_form.cost,
                                sale: price_form.sale,
                                description: price_form.description,
                                establishments: JSON.stringify(price_form.establishments),
                                type: price_form.type.id,
                                time_constraint: price_form.time_constraint?.id || '',
                                coach: price_form.coach?.id || '',
                                duration: price_form.duration?.id,
                                times: price_form.times?.id,
                                with_coach: price_form?.with_coach || '0',
                                one_time: price_form?.one_time || '0',
                                online_payment: price_form?.online_payment || '0',
                                renewal_discount: price_form.renewal_discount || '0',
                                hide_in_app: price_form?.hide_in_app || '0',
                                first_time_pay: price_form?.first_time_pay || '0'
                            })) }
                        >Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PriceForm;